import type { Router } from 'vue-router';

/**
 * Opens the "Biên bản giải thể" PDF viewer page in a new browser tab.
 *
 * Shared so every "In BBGT" / print button behaves the same way (open the
 * viewer route instead of a print modal).
 */
export function openBienBanGiaiThePdf(
  router: Router,
  idBienBanGiaiThe: number | string | null | undefined
): void {
  if (!idBienBanGiaiThe) return;

  const route = router.resolve({
    name: 'xem-bien-ban-giai-the',
    params: { id: String(idBienBanGiaiThe) },
  });

  window.open(route.href, '_blank');
}
